<style></style>

<template>
    <BTable 
        stacked="md" 
        :items="connectedPrograms" 
        :fields="connectedFields"
        show-empty 
        :empty-text="connectedEmptyText" 
        empty-filtered-text="No connected programs match filters" 
        :sort-by.sync="sortBy" 
        :sort-desc.sync="sortDesc" 
        :fixed="true"
    >
        <!-- <template v-slot:cell(user-info)="data" v-html="data.value"></template> -->
        <template v-slot:cell(name)="{item}">
            <a :href="$basePath+'/my-programs/'+item.id">{{item.name}}&nbsp;&nbsp;<i class="fas fa-angle-right"></i></a>
        </template>
        <template v-slot:cell(connected)="{item}">
            {{ formatDate(item.connected) }}
        </template>
        <template v-slot:cell(mostRecentAssessmentDate)="{item}">
            <div v-if="item.mostRecentAssessment" class="row icon-name-date">
                <div class="col-3 connected-icon">
                    <div v-bind:class="item.mostRecentAssessment.module.icon + ' icon-rounded-corners pull-left module-icons-sm bg-'+ item.mostRecentAssessment.module.color"></div>
                </div>
                <div class="col connected-name-date">
                    <div class="connected-name">{{item.mostRecentAssessment.module.name}}</div>
                    <div class="connected-date">{{ formatDate(item.mostRecentAssessment.finalized_at,'MM/DD/YYYY')}}</div>
                </div>
            </div>
        </template>
        <template v-slot:cell(mostRecentActionPlanDate)="{item}">
            <div v-if="item.mostRecentActionPlan" class="row icon-name-date">
                <div class="col-3 connected-icon">
                    <div v-bind:class="item.mostRecentActionPlan.icon + ' icon-rounded-corners pull-left module-icons-sm bg-'+ item.mostRecentActionPlan.color"></div>
                </div>
                <div class="col connected-name-date">
                    <div class="connected-name">{{item.mostRecentActionPlan.name}}</div>
                    <div class="connected-date">{{ formatDate(item.mostRecentActionPlan.date, 'MM/DD/YYYY')}}</div>
                </div>
            </div>
        </template>
        <template v-slot:cell(disconnect)="{item}">
            <a class="btn-orange-blue btn-sm"
                @click="disconnect(item, 'connected')"
            >
                Disconnect
            </a>
            <a class="btn-x" 
                @click="disconnect(item, 'connected')"
            >
                <i class="fa fa-times" aria-hidden="true"></i>
            </a>
        </template>
    </BTable>
</template>

<script>

    export default {
        components: {},
        props: {
            sortBy: {
                required: false,
                default: 'user-info'
            },
            sortDesc: {
                required: false,
                default: false
            }
        },
        data() {
            return {
                connectedPrograms: [],
                connectedFields: [
                    {
                        key: 'name',
                        label: 'User Information',
                        sortable: true,
                        thStyle: {width: '30%'}
                    },
                    {
                        key: 'connected',
                        label: 'Connected',
                        sortable: true
                    },
                    {
                        key: 'mostRecentAssessmentDate',
                        label: 'Most Recent Self-Assessment',
                        sortable: true,
                        class: 'td-connected-sa'
                    },
                    {
                        key: 'mostRecentActionPlanDate',
                        label: 'Most Recent Action Planning',
                        sortable: true,
                        class: 'td-connected-ap'
                    },
                    {
                        key: 'disconnect',
                        label: 'Disconnect',
                        sortable: false
                    }
                ],
                loadingConnectedPrograms: false,
            }
        },
        computed: {
            connectedEmptyText: function() {
                if (this.loadingConnectedPrograms) {
                    return 'Loading...'
                }
                return 'You are not yet connected to any programs';
            },
            formatDate(dateString, format = 'MM/DD/YY') {
                if (moment(dateString).isValid()) {
                    return moment(dateString).utc().format(format)
                }
                return null
            },
            $basePath() {
              return window.basePath;
            }
        },
        methods: {
            getConnectedPrograms(){
                this.loadingConnectedPrograms = true;
                axios('/api/consultants/connected-programs')
                    .then((response) => {
                        this.connectedPrograms = response.data.data;
                        var children_served = 0;
                        for( var i = 0; i< this.connectedPrograms.length ; i++ ) {
                          children_served = children_served + this.connectedPrograms[i].children;
                        }
                        this.loadingConnectedPrograms = false;
                    })
                    .catch((error) => {
                        console.error(error);
                        this.loadingConnectedPrograms = false;
                    })
            },
            disconnect(item){
                axios('/api/consultants/disconnect-program/'+item.id)
                    .then(function (response) {
                        // TODO: just remove the item from the list instead of reloading 
                        // window.location.reload();
                        console.log(this.connectedPrograms.indexOf(item))
                        this.connectedPrograms.splice(this.connectedPrograms.indexOf(item), 1);
                    }.bind(this))
                    .catch(function (error) {
                        console.error(error);
                    })
            },
        },
        mounted: function(){
            this.getConnectedPrograms()
        }        
    }
</script>